/**
 * This type defines the structure of the environment configuration for the application.
 */
export type Environment = {
    environment: string;
    webApiUrl: string;
    webApiKey: string;
    adfsUrl: string;
    entraIdClientId: string;
    entraIdApiKey: string;
    entraIdUrl: string;
    entraIdPreferredDomain: 'TEST' | 'PROD' | undefined;
    entraIdForced?: boolean;
}

class GlobalConfig {
    private static instance: GlobalConfig | undefined;

    config: Environment | null = null;

    getInstance(): GlobalConfig {
        if (GlobalConfig.instance === undefined) {
            GlobalConfig.instance = new GlobalConfig();
        }
        return GlobalConfig.instance;
    }

    get(): Environment | null {
        if (!this.config) {
            console.log("Global config has not been defined yet.");
            return null;
        }

        return this.config;
    }

    set(value: Environment): void {
        if (!this.config) {
            this.config = value;
        }
    }
}

export const env = new GlobalConfig().getInstance();
